export default [
  {
    title: 'Зарегистрирован по убыванию',
    field: 'created_at.desc',
    options: {
      by: 'created_at',
      order: 'desc'
    }
  },
  {
    title: 'Зарегистрирован по возрастанию',
    field: 'created_at.asc',
    options: {
      by: 'created_at',
      order: 'asc'
    }
  },  
  {
    title: 'Имя (А-Я)',
    field: 'name.asc',
    options: {
      by: 'name',
      order: 'asc'
    }
  },
  {
    title: 'Имя (Я-А)',
    field: 'name.desc',
    options: {
      by: 'name',
      order: 'desc'
    }
  },   
]